exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel-success>.panel-heading{color:#fff;background-color:#1abc9c;border-color:#d6e9c6}.panel-heading>p{font-size:22px;margin-bottom:0}.panel-body>p{font-size:20px;margin:5px}@media screen and (max-width:767px){.panel-heading>p{font-size:18px}.panel-body>p{font-size:1pc;margin:3x}}label[for=print-copies]{font-size:25px;margin-top:-8px;margin-left:10px}.cl{margin-top:2px;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/task-setting.vue
// module id = 58
// module chunks = 0